import * as React from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { Button } from 'semantic-ui-react';

import { HOCPanel } from '../../../components/Panel/Panel';
import { LEARN_PAGE_PATH } from '../../../shared/constants';
import { formatMessageHelper, FormattedMessageHelper } from '../../../shared/helpers/internationalization';

import './LearnNotFound.scss';

const Panel = HOCPanel();

export const LearnNotFound = () => {
  const intl = useIntl();
  return (
    <Panel title={formatMessageHelper(intl, 'learnNotFound.title')}>
      <div className="learn-not-found">
        <FormattedMessageHelper id="learnNotFound.content.1" tagName="p" />
        <FormattedMessageHelper id="learnNotFound.content.2" tagName="p" />
        <Link to={LEARN_PAGE_PATH}>
          <Button
            as="div"
            primary
            compact
            icon="angle right"
            labelPosition="right"
            content={formatMessageHelper(intl, 'learnNotFound.backToLearn')}
          />
        </Link>
      </div>
    </Panel>
  );
};
